export default __webpack_public_path__ + "static/media/copy.ab8f7bc8.svg";